import styled from 'styled-components'

import { Content } from '../../components/container/Content'
import { AlignCenterItem, RowBetween } from '../../components/common'
import { FOOTER_MIN_HEIGHT } from '../../components/footer'

import { Color } from '../../theme/color'

export const StyledContent = styled(Content)`
  padding-bottom: ${FOOTER_MIN_HEIGHT}px;
`

export const ProductInfoContainer = styled.div`
  padding: 16px;
`

export const OrderInfoContainer = styled.div`
  padding: 40px 24px 16px;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  background-color: ${Color.white};
`

export const AmountInputActiveBorder = styled.div`
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 1px;
  border-bottom: 2px solid ${Color.primary_5};
  transform: translateX(-50%);
`

export const AmountInputContainer = styled.div<{ textWidth?: number }>`
  display: block;
  position: relative;
  width: 100%;
  &::before {
    display: block;
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    border-bottom: 2px solid ${Color.line};
  }
  &::after {
    display: ${({ textWidth }) => (textWidth ? 'block' : 'none')};
    content: '주';
    position: absolute;
    top: 50%;
    left: calc(50% + 8px + ${({ textWidth }) => textWidth}px / 2);
    font-size: 30px;
    font-weight: 600;
    color: ${Color.text_primary};
    transform: translate(-50%, -50%);
  }
  > input:focus ~ ${AmountInputActiveBorder} {
    width: 100%;
    transition: 0.25s;
  }
  > span {
    opacity: 0;
    position: absolute;
    font-size: 30px;
    font-weight: 600;
  }
  ${({ textWidth }) =>
    textWidth
      ? `
        > input {
          width: calc(100% - 26px);
        }
      `
      : ''}
`

export const AmountInput = styled.input`
  width: 100%;
  padding: 8px;
  outline: none;
  border: none;
  font-size: 30px;
  font-weight: 600;
  text-align: center;
  color: ${Color.text_primary};
  &::placeholder {
    font-size: 30px;
    font-weight: 500;
    color: ${Color.gray_4};
  }
`

export const AmountButtonBox = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 32px;
`

export const AmountButton = styled.button`
  padding: 8px 16px;
  border: 1px solid ${Color.gray_3};
  border-radius: 4px;
  background-color: ${Color.white};
  font-size: 14px;
  font-weight: 500;
  color: ${Color.text_primary};
`

export const CostContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 64px 0 16px;
`

export const ResultAmountBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  > ${RowBetween} {
    width: 100%;
  }
`

export const TermsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
`

export const TermsItem = styled(AlignCenterItem)`
  padding: 8px 0;
  cursor: pointer;
  > svg {
    margin-right: 8px;
  }
`

export const EventTerms = styled.div`
  margin-top: 4px;
  padding-top: 4px;
  border-top: 1px solid ${Color.line};
`

export const EventTermsItem = styled(RowBetween)`
  padding: 8px 0;
  cursor: pointer;
`
